/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module AlertEmailModule
 */

import { L10nService } from '@vmw/ngx-vip';
import { AviPermissionResource } from 'generated-types';
import { AlertEmailModalComponent } from 'ng/modules/alert';
import { withFullModalMixin } from 'ajs/js/utilities/mixins';
import { ObjectTypeItem } from 'ajs/modules/data-model/factories/object-type-item.factory';
import { AlertEmailConfig } from 'object-types';
import * as globalL10n from 'global-l10n';

const { ...globalL10nKeys } = globalL10n;

/**
 * @description
 *
 *   AlertEmailConfig item.
 *
 * @author Guru Prasad H K
 */
export class AlertEmailConfigItem extends withFullModalMixin(ObjectTypeItem) {
    public static ajsDependencies = [
        'l10nService',
    ];

    private readonly l10nService: L10nService;

    constructor(args: {}) {
        const extendedArgs = {
            objectName: 'alertemailconfig',
            objectType: AlertEmailConfig,
            permissionName: AviPermissionResource.PERMISSION_ALERTEMAILCONFIG,
            windowElement: AlertEmailModalComponent,
            ...args,
        };

        super(extendedArgs);

        this.l10nService = this.getAjsDependency_('l10nService');
    }

    /** @override */
    public getModalBreadcrumbTitle(): string {
        return this.l10nService.getMessage(globalL10nKeys.emailLabel);
    }
}
